import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ADMIN_ROLES = ["admin", "superAdmin"];

export const isAdminProfile = (p) =>
  !!p && (p.isAdmin === true || ADMIN_ROLES.includes(p.role));

export const isSuperAdminProfile = (p) => !!p && p.role === "superAdmin";

const ProtectedRoute = ({ require = "any", children }) => {
  const { user, profile, loading, isAccountOwner } = useAuth();
  const location = useLocation();

  if (loading) return <div style={{ padding: 40 }}>Loading…</div>;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  if (require === "admin" && !isAdminProfile(profile))
    return <Navigate to="/" replace />;
  if (require === "superAdmin" && !isSuperAdminProfile(profile))
    return <Navigate to="/" replace />;
  if (require === "client" && !profile?.isClient)
    return <Navigate to="/" replace />;
  // Account owners manage their team; studio admins pass too (they administer
  // every account from the admin panel).
  if (require === "accountOwner" && !isAccountOwner && !isAdminProfile(profile))
    return <Navigate to="/dashboard" replace />;

  return children;
};

export default ProtectedRoute;
